import { render, staticRenderFns } from "./BatchGrant.vue?vue&type=template&id=7a6cdeb7&scoped=true"
import script from "./BatchGrant.vue?vue&type=script&lang=js"
export * from "./BatchGrant.vue?vue&type=script&lang=js"
import style0 from "./BatchGrant.vue?vue&type=style&index=0&id=7a6cdeb7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6cdeb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a6cdeb7')) {
      api.createRecord('7a6cdeb7', component.options)
    } else {
      api.reload('7a6cdeb7', component.options)
    }
    module.hot.accept("./BatchGrant.vue?vue&type=template&id=7a6cdeb7&scoped=true", function () {
      api.rerender('7a6cdeb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/customerPointsManagement/dialogs/BatchGrant.vue"
export default component.exports